import RpcResponse from "@/core/services/Rpc/RpcResponse";
import RpcService from "@/core/services/Rpc/RpcService";
import type RpcDataPagination from "@/core/services/Rpc/RpcDataPagination";
import type RpcDataSort from "@/core/services/Rpc/RpcDataSort";
import ProductCodeMapping from "@/domains/ProductCodeMappings/ProductCodeMapping";

class ProductCodeMappingsDAO {
  static async get(params: { id: number }): Promise<RpcResponse> {
    return await RpcService.makeRequest('productCodeMappings.get', params);
  }

  static async getList(
    params?: { id?: number },
    pagination?: RpcDataPagination,
    sort?: RpcDataSort
  ): Promise<RpcResponse> {
    return await RpcService.makeRequest(
      'productCodeMappings.getList',
      params,
      pagination,
      sort
    );
  }

  static async add(productCodeMapping: ProductCodeMapping): Promise<RpcResponse> {
    return await RpcService.makeRequest('productCodeMappings.add', {productCodeMapping});
  }

  static async update(productCodeMapping: ProductCodeMapping): Promise<RpcResponse> {
    return await RpcService.makeRequest('productCodeMappings.update', {productCodeMapping});
  }

  static async delete(id: number): Promise<RpcResponse> {
    return await RpcService.makeRequest('productCodeMappings.delete', { id });
  }

}

export default ProductCodeMappingsDAO;
